import React, { useState } from 'react';
import { useStateValue } from '../context/StateProvider';
import RowContainerSearch from './RowcontainerSearch';
import SearchBar from './SearchBar';

const JobSearch = () => {
  const [{ Products }] = useStateValue();
  const [filters, setFilters] = useState({
    searchQuery: '',
    location: '',
  });

  // Function to handle filter input changes
  const handleInputChange = (e) => {
    setFilters({
      ...filters,
      [e.target.name]: e.target.value,
    });
  };

  const filteredProducts = Products
    ? Products.filter((item) => {
      const combinedFields = `${item.jobTitle} ${item.companyName} ${item.experienceRequired} ${item.salary} ${item.jobType}`.toLowerCase();
      return (
        (!filters.searchQuery || combinedFields.includes(filters.searchQuery.toLowerCase())) &&
        (!filters.location || item.location.toLowerCase().includes(filters.location.toLowerCase()))
      );
    })
    : []; // If Products is null or undefined, default to an empty array

  return (
      <section
      className="w-full max-w-[1320px] h-auto px-4 py-6 flex items-left flex-col  mx-auto bg-white md:mt-20"
    >
      <h2 className='text-[36px] text-[#515151] font-[400] text-left'>Nexify is Now Hiring!</h2>
      <SearchBar filters={filters} handleInputChange={handleInputChange} />
      <RowContainerSearch flag={false} data={filteredProducts} />
      
    </section>
  );
};

export default JobSearch;
